var _path, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSentActiveIcon = function SvgSentActiveIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1200_36",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 59V1H1.5V59H59.5Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1200_36)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5293 7.454C14.5293 12.3703 10.7818 18.5803 8.94521 21.3285C8.47705 22.029 7.44603 22.0208 6.98795 21.3138C5.16052 18.4933 1.37888 12.0961 1.37888 7.454C1.37888 3.8226 4.32275 0.878845 7.95416 0.878845C11.5856 0.878845 14.5293 3.8226 14.5293 7.454Z",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9541 4.79091C9.50496 4.79091 10.7623 6.04821 10.7623 7.59907C10.7623 9.14993 9.50496 10.4071 7.9541 10.4071C6.40324 10.4071 5.14594 9.14993 5.14594 7.59907",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.8954 51.6324C58.8797 49.3531 59.6211 46.912 59.6211 44.7262C59.6211 41.0949 56.6772 38.1509 53.0459 38.1509C49.4145 38.1509 46.4707 41.0949 46.4707 44.7262C46.4707 49.3684 50.2521 55.7655 52.0797 58.5859C52.5376 59.2929 53.5689 59.301 54.0368 58.6007C54.521 57.8762 55.1382 56.9097 55.7843 55.7912",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.854 44.8712C55.854 46.4221 54.5967 47.6792 53.0459 47.6792C51.495 47.6792 50.2377 46.4221 50.2377 44.8712C50.2377 43.3203 51.495 42.063 53.0459 42.063C54.5967 42.063 55.854 43.3203 55.854 44.8712Z",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7409 34.4244H10.794C5.59417 34.4244 1.37894 38.6397 1.37894 43.8394C1.37894 49.0393 5.59417 53.2546 10.794 53.2546H45.2868",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2747 16.1596H40.958C46.0016 16.1596 50.0904 20.2483 50.0904 25.292C50.0904 30.3358 46.0016 34.4244 40.958 34.4244H37.7626",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0352 42.2819H18.7241C18.3367 42.2819 18.0227 41.9678 18.0227 41.5803V27.2685C18.0227 26.881 18.3367 26.5669 18.7241 26.5669H33.0352C33.4227 26.5669 33.7367 26.881 33.7367 27.2685V41.5803C33.7367 41.9678 33.4227 42.2819 33.0352 42.2819Z",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4956 33.1085H23.2638V26.5668H28.4956V33.1085Z",
    stroke: "#E4858C",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSentActiveIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sent-active-icon.2c715e8a.svg";
export { ForwardRef as ReactComponent };